import React from "react";
import ReactDOM from "react-dom";

import { store, StoreContext } from "./store";
import { App, StyleProvider } from "./components";

ReactDOM.render(
  <StyleProvider>
    <StoreContext.Provider value={store}>
      <App />
    </StoreContext.Provider>
  </StyleProvider>,
  document.getElementById("root")
);
